module.exports = __webpack_public_path__ + "static/img/a65.d013078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a65.png
// module id = rmbQ
// module chunks = 73